import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {FeeCatType} from '../types';

export const useGetFeeCat = () => {
  const [feeCat, setFeeCat] = useState<FeeCatType[]>([]);
  const [feeCatLoading, setFeeCatLoading] = useState<boolean>(false);

  const getFeeCat = async () => {
    setFeeCatLoading(true);

    try {
      const response = await axios.get(URLS.GET_FEE_CAT_LOCAL);
      setFeeCat(response.data.feeCat);
    } catch (error) {
      console.error(error);
    } finally {
      setFeeCatLoading(false);
    }
  };

  useEffect(() => {
    getFeeCat();
  }, []);

  return {feeCatLoading, feeCat};
};
